import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { isEmpty } from 'utils/types';
import { selectors as errorsSelectors } from 'state/errors';
import { selectors as settingsSelectors } from 'state/settings';
import { selectors as orderSelectors, selectorsByType } from 'state/order';
import { getPriceConceptsAndTotalPrices } from 'utils/order';
import SummaryPrice from 'components/summary/SummaryPrice/SummaryPrice.styled';
import { withTranslation } from 'react-i18next';

const enhance = compose(
  withTranslation('Quote'),
  connect((state, { typeOfOrder }) => {
    const orderType = typeOfOrder || orderSelectors.getTypeOfOrder(state);

    return {
      currencySymbol: settingsSelectors.getCurrency(state).symbol,
      isFetching: selectorsByType.ui[orderType].getIsFetching(state),
      error: selectorsByType.quote[orderType].getQuoteError(state),
      errors: errorsSelectors.getErrors(state),
      quote: selectorsByType.quote[orderType].getQuote(state),
      orderType,
    };
  }),
  withProps(({ t, quote, isFetching, error }) => {
    const isDataReady = !isEmpty(quote);
    let concepts = [];
    let totalPrices = [];

    if (isDataReady) {
      const pricesAndConcepts = getPriceConceptsAndTotalPrices({
        quote,
        t,
      });
      concepts = pricesAndConcepts.concepts;
      totalPrices = pricesAndConcepts.totalPrices;
    }

    return {
      quote,
      isDataReady,
      isFetching,
      concepts,
      totalPrices,
      hasError: error,
    };
  })
);

export default enhance(SummaryPrice);
